var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 0.896484V2.89648M7.5 0.896484V2.89648M1 4.89648H10M2 1.89648H9C9.55229 1.89648 10 2.3442 10 2.89648V9.89648C10 10.4488 9.55229 10.8965 9 10.8965H2C1.44772 10.8965 1 10.4488 1 9.89648V2.89648C1 2.3442 1.44772 1.89648 2 1.89648Z",
    stroke: "black",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.8c924d2482ac563c562b23ff7c8b6306.svg";
export { ForwardRef as ReactComponent };